import React, { useCallback } from 'react';

import { connect } from 'Modules/core/redux';
import { Text, Heading, Button, cn } from 'Modules/ui';
import { storageActions } from 'Modules/business/data';
import { translate } from 'Modules/core/i18n';

import { FactorinView } from '../FactorinView';
import styles from './index.module.scss';


const DocumentsViewPlaceholder = ({ t }) => (
    <Text component='div' textType='info' className={styles.documentsViewPlaceholder}>
        {t('placeholder')}
    </Text>
);

const DocumentsViewNoBatchUidPlaceholder = connect(
    null,
    {
        refresh: storageActions.loadItem('documents'),
    },
)(({ document, refresh, t, error }) => error
    ? (
        <div className={cn(styles.documentsViewPlaceholder, styles.error)}>
            <Heading component='h1' headingType='h1Element'>
                {t('error')}
            </Heading>
            <p>
                {error}
            </p>
        </div>
    ) : (
        <div className={cn(styles.documentsViewPlaceholder, styles.importing)}>
            <p>
                {t('noBatchUidPlaceholder')}
            </p>
            <Button
                variant='accent'
                onClick={useCallback(
                    () => refresh(document.Uid),
                    [document.Uid, refresh],
                )}
            >
                {t('buttons.refresh')}
            </Button>
        </div>
    ));

const DocumentsViewComponent = ({ document, t, ...props }) =>
    !document
        ? <DocumentsViewPlaceholder t={t} />
        : !document.BatchUId
            ? (
                <DocumentsViewNoBatchUidPlaceholder
                    document={document}
                    error={document.ImportResult || document.LastErrorMessage}
                    t={t}
                />
            ) : (
                <FactorinView
                    editableColumns
                    name={(
                        <Heading component='h1' headingType='h1Element'>
                            {t('headerTable')}
                        </Heading>
                    )}
                    {...props}
                />
            );

export const DocumentsView = translate('documentsView')(DocumentsViewComponent);
